import { Component, Input, ViewEncapsulation } from '@angular/core';
import { FuseNavigationItem } from '@fuse/components/navigation/navigation.types';
import { MatDialog } from '@angular/material/dialog';
import { OrderListWrapperComponent } from '../../../../pages/invoice/printable/compact/order-list-wrapper/order-list-wrapper.component';
import { SwitchPosOrderComponent } from '../../switch-pos-order/switch-pos-order.component';
import { AddPosComponent } from '../../add-pos/add-pos.component';
import { Router } from '@angular/router';
import { AccountsManagerComponent } from '../../accounts-manager/accounts-manager.component';
import { PosDetailWithOrders } from '../../../../../../core/models/pos.model';
import { FindProductByNumberComponent } from '../../find-product-by-number/find-product-by-number.component';
import { ShowQrCodeComponent } from '../../show-qr-code/show-qr-code.component';
import { PrintService, PrintUserContext } from '../../../../../../core/services/print.service';
import { ToastrService } from 'ngx-toastr';
import { PosService } from '../../../services/pos.service';

@Component({
  selector: 'table-sidebar',
  template: `
    <div class="py-10">
      <!-- Add any extra content that might be supplied with the component -->
      <div class="extra-content">
        <ng-content></ng-content>
      </div>

      <fuse-vertical-navigation
        [appearance]="'default'"
        [navigation]="menuData"
        [inner]="true"
        [mode]="'side'"
        [name]="'demo-sidebar-navigation'"
        [opened]="true"
      ></fuse-vertical-navigation>
    </div>
  `,
  styles: [
    `
      demo-sidebar fuse-vertical-navigation .fuse-vertical-navigation-wrapper {
        box-shadow: none !important;
      }
    `
  ],
  encapsulation: ViewEncapsulation.None
})
export class TableSidebarComponent {
  menuData: FuseNavigationItem[];
  @Input() pos: PosDetailWithOrders;
  orderTotal: number;

  /**
   * Constructor
   */
  constructor(
    private _matDialog: MatDialog,
    private posService: PosService,
    private router: Router,
    private printService: PrintService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.menuData = [
      {
        title: 'Ações',
        type: 'group',
        children: [
          {
            title: 'Ver lista de pedidos',
            type: 'basic',
            icon: 'mat_outline:receipt',
            function: (item: FuseNavigationItem): void => {
              this.showOrder();
            }
          },
          // {
          //   title: 'Tirar talao de controlo',
          //   type: 'basic',
          //   icon: 'heroicons_outline:receipt-tax',
          //   function: (item: FuseNavigationItem): void => {
          //     this.printControlReceipt();
          //   }
          // },
          {
            title: 'Pagar',
            type: 'basic',
            icon: 'heroicons_outline:cash',
            function: (item: FuseNavigationItem): void => {
              this.goToPayment();
            }
          },
          {
            title: 'Inserir codigo',
            type: 'basic',
            icon: 'mat_outline:manage_search',
            function: (item: FuseNavigationItem): void => {
              this.openFindProductByNumber();
            }
          }
          // {
          //   title: 'Enviar para cozinha',
          //   type: 'basic',
          //   icon: 'mat_outline:food_bank',
          //   function: (item: FuseNavigationItem): void => {
          //     // this.sendToKitchen();
          //   }
          // }
        ]
      },
      {
        type: 'divider'
      },
      {
        title: 'Mesa',
        type: 'group',
        children: [
          {
            title: 'Mudar nome',
            type: 'basic',
            icon: 'heroicons_outline:pencil',
            function: (item: FuseNavigationItem): void => {
              const dialogRef = this._matDialog.open(AddPosComponent, {
                width: '100vw',
                data: { name: this.pos.pos.name } // Pass the current table name as a starting value
              });
            }
          },
          {
            title: 'Mover pedidos para outra mesa',
            type: 'basic',
            icon: 'heroicons_solid:switch-horizontal',
            function: (item: FuseNavigationItem): void => {
              this.posService.getPosList().subscribe(pos => {
                const dialogRef = this._matDialog.open(SwitchPosOrderComponent, {
                  width: '100vw',
                  data: {
                    tables: pos,
                    table: this.pos.pos
                  }
                });
              });
            }
          },
          {
            title: 'Gerir contas',
            type: 'basic',
            icon: 'heroicons_solid:user-group',
            function: (item: FuseNavigationItem): void => {
              const dialogRef = this._matDialog.open(AccountsManagerComponent, {
                width: '100vw',
                data: {
                  pos: this.pos
                }
              });
            }
          },
          {
            title: 'Ver QR code',
            type: 'basic',
            icon: 'mat_solid:qr_code',
            function: (item: FuseNavigationItem): void => {
              this.showQRCode();
            }
          }
        ]
      }
    ];
  }

  private showOrder(): void {
    const dialogRef = this._matDialog.open(OrderListWrapperComponent, {
      height: '100vh',
      width: '100vw',
      panelClass: 'receiptOnModal',
      autoFocus: false,
      data: {
        pos: this.pos,
        orders: this.pos?.orders,
        isViewOnly: true
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Order view closed');
    });
  }

  private goToPayment() {
    this.router.navigate(['ecommerce/pay/' + this.pos.pos.id]);
  }

  private openFindProductByNumber(): void {
    const dialogRef = this._matDialog.open(FindProductByNumberComponent, {
      height: '100vh',
      width: '100vw',
      panelClass: 'receiptOnModal',
      data: { showCloseButton: true },
      autoFocus: false
    });

    dialogRef.afterClosed().subscribe(result => {
      // dialog closed
    });
  }

  /**
   * Print control chit (Tira Talão de Controlo) to ESC/POS printer
   */
  private printControlReceipt() {
    const user = JSON.parse(localStorage.getItem('user')) as PrintUserContext | null;

    if (!user || !this.pos?.orders) {
      this.toastr.error('Unable to print: missing user or order data');
      return;
    }

    this.printService.printControlReceipt(this.pos, user, this.orderTotal);
  }

  private sendToKitchen() {
    // Implement sending orders to the kitchen
    // This could involve calling a service to update the order status
    // or sending a notification to the kitchen staff
    console.log('Sending orders to kitchen for table:', this.pos.pos.name);
    // TODO: Implement actual kitchen notification logic
  }

  private showQRCode() {
    const dialogRef = this._matDialog.open(ShowQrCodeComponent, {
      panelClass: 'receiptOnModal2',
      data: {
        pos: this.pos
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('QR code dialog closed');
    });
  }
}
